<template>
  <div>
    <p>camara</p>
    <input type="file" @change="uploadCamara" value="Camaras" />
    <p>flujo</p>
    <input type="file" @change="uploadFlujo" value="red_as" />
    <b-button @click="calcular">Join</b-button>
  </div>
</template>

<script>
import Http from "../Http";

export default {
  name: "importGeojson",
  data: () => ({
    red: [],
    camara: []
  }),
  methods: {
    uploadFlujo(e) {
      let file = e.target.files || e.dataTransfer.files;
      console.log(file[0]);
      let lector = new FileReader();
      let tmp = this;
      lector.onload = function(e) {
        let contenido = e.target.result;
        tmp.readFlujo(contenido);
      };
      lector.readAsText(file[0]);
    },
    readFlujo(data) {
      let tmp = JSON.parse(data).features.map(x => ({
        type: x.type,
        id: x.properties.IDENTIFICA,
        geometry: x.geometry,
        properties: {
          OBJECTID_1: x.properties.OBJECTID_1,
          OBJECTID: x.properties.OBJECTID,
          IDENTIFICA: x.properties.IDENTIFICA,
          DIAMETRO: x.properties.DIAMETRO,
          MATERIAL: x.properties.MATERIAL,
          PENDIENTE: x.properties.PENDIENTE,
          COTAINICIO: x.properties.COTAINICIO,
          COTATERMIN: x.properties.COTATERMIN,
          SUBTYPE: x.properties.SUBTYPE,
          IDSV: x.properties.IDSV,
          ORDEN: x.properties.ORDEN,
          X: x.properties.X,
          Y: x.properties.Y,
          SHAPE_Leng: x.properties.SHAPE_Leng,
          FECHA_EXTR: x.properties.FECHA_EXTR,
          Shape_Le_1: x.properties.Shape_Le_1,
          xgeo_1: x.properties.xgeo_1,
          ygeo: x.properties.ygeo,
          state: 0
        }
      }));
      tmp = tmp.filter(x => x.properties.IDSV !== 0);
      this.upFlujo(tmp);
    },
    upFlujo(datajson) {
      if (datajson.length > 0) {
        let IDSV = datajson[0].properties.IDSV;
        let dt = datajson.filter(x => x.properties.IDSV === IDSV);
        let tramo = dt.map(x => ({
          identifica: x.properties.IDENTIFICA,
          shape_id: IDSV,
          datajson: JSON.stringify(x),
          geopoint: `POINT(${x.properties.ygeo.replace(",",".")} ${x.properties.xgeo_1.replace(",",".")})`
        }));
        console.log(tramo);
        Http.Http()
          .post(`Map/tramo`, { map: JSON.stringify(tramo) })
          .then(() => {
            let rm = datajson.filter(x => x.properties.IDSV !== IDSV);
            datajson = [];
            this.upFlujo(rm);
          })
          .catch(err => console.log(err + "ddd"));
      }
    },
    uploadCamara(e) {
      let file = e.target.files || e.dataTransfer.files;
      console.log(file[0]);
      let lector = new FileReader();
      let tmp = this;
      lector.onload = function(e) {
        let contenido = e.target.result;
        tmp.readCamara(contenido);
      };
      lector.readAsText(file[0]);
    },
    readCamara(data) {
      let tmp = JSON.parse(data).features.map(x => ({
        type: x.type,
        id: x.properties.IDENTIFICA,
        geometry: x.geometry,
        properties: x.properties
      }));
      tmp = tmp.filter(x => x.properties.IDSV !== 0);
      this.upCamara(tmp);
    },
    upCamara(datajson) {
      if (datajson.length > 0) {
        let IDSV = datajson[0].properties.IDSV;
        let dt = datajson.filter(x => x.properties.IDSV === IDSV);
        let camara = dt.map(x => ({
          identifica: x.properties.IDENTIFICA,
          shape_id: IDSV,
          datajson: JSON.stringify(x)
        }));

        console.log(camara);
        Http.Http()
          .post(`Map/camara`, { map: JSON.stringify(camara) })
          .then(() => {
            let rm = datajson.filter(x => x.properties.IDSV !== IDSV);
            datajson = [];
            this.upCamara(rm);
          })
          .catch(err => console.log(err + "ddd"));
      }
    },
    calcular() {
      if (this.camara.length > 0 && this.red.length > 0) {
        this.camara.forEach(x => {
          let tmp = x.geometry.coordinates;
          this.red.forEach(y => {
            if (
              y.geometry.coordinates[0] == tmp ||
              y.geometry.coordinates[1] == tmp
            ) {
              x.properties.IDSV = y.properties.IDSV;
            }
          });
        });
        console.log(this.camara);
      }
    }
  }
};
</script>

<style scoped></style>
